// Single source of truth for public business/support info (no secrets).
export const BUSINESS = {
  name: "Mas Tofa AI",
  tagline: "AI untuk Video Jualan",
  address: {
    line1: "Jl. Raya Soekarno-Hatta No. 381",
    line2: "Bugangin, Kec. Kendal",
    line3: "Kabupaten Kendal, Jawa Tengah 51314",
  },
  whatsappDisplay: "0851-5700-9099",
  whatsappNumber: "6285157009099",
};

export const WA_MESSAGE = "Halo Mas Tofa, saya membutuhkan bantuan terkait Mas Tofa AI.";

export const waLink = (message = WA_MESSAGE) =>
  `https://wa.me/${BUSINESS.whatsappNumber}?text=${encodeURIComponent(message)}`;

export const LEGAL_LINKS = [
  { to: "/tentang", label: "Tentang Kami" },
  { to: "/privacy-policy", label: "Kebijakan Privasi" },
  { to: "/syarat-ketentuan", label: "Syarat & Ketentuan" },
  { to: "/refund-policy", label: "Kebijakan Pembatalan & Pengembalian" },
  { to: "/bantuan", label: "Pusat Bantuan" },
  { to: "/kontak", label: "Kontak / Bantuan" },
];

export const formatRupiah = (n) => {
  const v = Number(n || 0);
  return "Rp" + v.toLocaleString("id-ID");
};
